module.exports = __webpack_public_path__ + "static/media/textile-collection-min.68a863bf.png";